import { __decorate, __metadata } from "tslib";
import { IsUndefinable, StoreItemValidityEnum } from '@goparrot/common';
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsEnum, IsNotEmpty, IsString, MaxLength } from 'class-validator';
import { CartExposeGroup } from '../../cart/interface';
import { OrderElementTypeEnum } from '../enum';
import { OrderExposeGroup } from '../interface';
export class PatchOrderItemDto {
}
__decorate([
    ApiPropertyOptional({ type: OrderElementTypeEnum, example: OrderElementTypeEnum.PROPERTY }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsEnum(OrderElementTypeEnum, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], PatchOrderItemDto.prototype, "type", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Item title' }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(500, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], PatchOrderItemDto.prototype, "title", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'storeItem unique ID (per store and item type)' }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(500, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], PatchOrderItemDto.prototype, "uid", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Item pos_guid if there is a real POS provider, uniqueName if POS is GoParrot' }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(500, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], PatchOrderItemDto.prototype, "guid", void 0);
__decorate([
    ApiPropertyOptional({ enum: StoreItemValidityEnum, description: 'VALID by default', example: StoreItemValidityEnum.VALID }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsEnum(StoreItemValidityEnum, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], PatchOrderItemDto.prototype, "validity", void 0);
//# sourceMappingURL=PatchOrderItemDto.js.map